<template>
  <!-- The site footer, by theme (WEB_V2_BUILD.md §4 "footer" slot): today's
       footer (LegacyFooter) for Glass, Flat, Night Watch and the classic themes
       until the business picks a footer kind; the new footers (cta, local,
       minimal, columns) for every other theme. Flat always keeps today's. -->
  <LegacyFooter v-if="kind === 'classic'" v-bind="$attrs" :company-name="companyName" :company-tagline="companyTagline"
                :registration-info="registrationInfo" :colors="colors" :footer-links="footerLinks"
                :social-links="socialLinks" :show-credits="showCredits" @show:credits="emit('show:credits')" />
  <SiteFooter v-else v-bind="$attrs" :kind="kind" :company-name="companyName" :company-tagline="companyTagline"
              :registration-info="registrationInfo" :social-links="socialLinks" :show-credits="showCredits"
              @show:credits="emit('show:credits')" />
</template>

<script setup>
import {computed, defineAsyncComponent} from "vue";
import {storeToRefs} from "pinia";
import {useColorStore} from "@/classes/useColorStore.js";
import {usePageStore} from "@/stores/pageStore.js";
import {footerKind} from "@/themes/layouts.js";

const LegacyFooter = defineAsyncComponent(() => import("./LegacyFooter.vue"));
const SiteFooter = defineAsyncComponent(() => import("@/themes/footer/SiteFooter.vue"));

defineOptions({inheritAttrs: false});
defineProps({
  companyName: {type: String, default: ""},
  companyTagline: {type: String, default: ""},
  registrationInfo: {type: String, default: ""},
  colors: {type: Object, default: () => ({})},
  footerLinks: {type: Array, default: undefined},
  socialLinks: {type: Array, default: () => []},
  showCredits: {type: Boolean, default: true},
});
const emit = defineEmits(["show:credits"]);

const {theme} = storeToRefs(useColorStore());
const pageStore = usePageStore();
const kind = computed(() => footerKind(theme.value, pageStore.pageData || {}));
</script>
